import { MdRefInfo } from './MdRefInfo';

/**
 * 动态属性信息
 * @author wangjiegj<wangjiegj@inspur.com>
 */


/**
 * 动态属性信息
 */
export class DynamicPropSetInfo {
  constructor() {}

  // /**
  //  * 是否启用动态属性集合
  //  */
  // EnableDynamicProp: boolean;

  /**
   * 动态属性集合持久化构件
   */
  DynamicPropRepositoryComp: MdRefInfo;

  /**
   * 动态属性集合序列化构件
   */
  DynamicPropSerializerComp: MdRefInfo;

}
